import React from 'react';
import classNames from 'classnames';
import ICWarning from 'Assets/images/commons/label_warning.svg';

import styles from './FieldDecorator.less';

const types = {
  warning: styles.warning,
};

// eslint-disable-next-line react/prop-types
const FieldDecorator = ({ label, type, visible, children }) => {
  return (
    <div
      className={classNames(styles.container, types[type], {
        [styles.visible]: visible,
      })}>
      <div className={styles.label}>
        {type === 'warning' && <img src={ICWarning} alt="Warning" />}
        <span>{label}</span>
      </div>
      {children}
    </div>
  );
};

export default FieldDecorator;
